export default () => {
  // Monitor if the value of the variation has changed, if so, set the variation ID
  jQuery('input.variation_id').change(() => {
    jQuery('input.sample_variation_id').val(jQuery('input.variation_id').val())
    if (document.getElementById('pa_afmetingen')) {
      const priceContainer = document.querySelector('.js-woo-default-variation-price')
      const priceField = document.querySelector('.js-woo-price')

      if (priceContainer) {
        const bdi = priceContainer.querySelector('bdi')
        const cleanPrice = bdi.innerHTML
          .replace(/(<([^>]+)>)/gi, '')
          .replace('€&nbsp;', '')
        if (priceField) {
          priceField.innerHTML = cleanPrice
        }
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/js/woocommerce/MonitorVariationChange.js